/* Visible purchase choices; exact-box updates share the durable box-edit journal. */
(function (global) {
  'use strict';
  let sequence=0;
  function render(node,choices,selected,onChange){
    const name=node.dataset.purchaseName||(node.dataset.purchaseName=`purchase-choice-${++sequence}`);
    const focused=node.contains(document.activeElement)?document.activeElement.value:null;
    node.replaceChildren(...choices.map(choice=>{
      const label=document.createElement('label');label.className='purchase-choice';
      const input=document.createElement('input');input.type='radio';input.name=name;input.value=String(choice.id);input.checked=Number(selected)===Number(choice.id);
      const copy=document.createElement('span'),title=document.createElement('strong'),detail=document.createElement('small');
      title.textContent=choice.name;detail.textContent=choice.detail;copy.append(title,detail);label.append(input,copy);
      input.addEventListener('change',()=>onChange(Number(input.value)));return label;
    }));
    if(focused!==null)[...node.querySelectorAll('input')].find(x=>x.value===focused)?.focus({preventScroll:true});
  }
  global.JoburgPurchaseCards={render};
  async function initCart(node){
    const grid=node.querySelector('[data-cart-purchase-cards]'),status=node.querySelector('[data-purchase-status]'),id=node.dataset.cartPurchaseBox;
    const catalog=JSON.parse(node.querySelector('[data-purchase-catalog]').textContent);
    const key='joburg-box-edit-intent-v1';
    const journal={get:()=>JSON.parse(localStorage.getItem(key)||'null'),set:v=>v?localStorage.setItem(key,JSON.stringify(v)):localStorage.removeItem(key)};
    const cartUrl=global.joburgTheme?.cartUrl||'/cart';
    const request=async(url,body)=>{
      const r=await fetch(url,{cache:'no-store',...(body?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{})});
      if(!r.ok)throw Object.assign(Error('Your box could not be updated. Please check availability and try again.'),{rejected:r.status>=400&&r.status<500});
      return r.json();
    };
    const api={read:()=>request(`${cartUrl}.js`),add:items=>request(`${cartUrl}/add.js`,{items}),update:updates=>request(`${cartUrl}/update.js`,{updates})};
    let busy=false;
    try{
      if(journal.get())return;
      const cart=await api.read(),box=global.JoburgBoxEdit.open(cart,id,catalog);
      const plans=(catalog[0]?.sellingPlans||[]).filter(p=>catalog.every(c=>c.sellingPlans.some(x=>x.id===p.id)));
      if(!plans.length)return;
      const money=c=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:cart.currency||'USD'}).format(c/100);
      const price=plan=>box.lines.reduce((sum,line)=>{const p=catalog.find(c=>c.variantId===line.variant_id);return sum+(plan?p.sellingPlans.find(x=>x.id===plan).price:p.price)*line.quantity;},0);
      const choices=[{id:0,name:'One-time purchase',detail:`${money(price(0))} for this box · before extra cart savings`},...plans.map(p=>({id:p.id,name:p.name,detail:`${money(price(p.id))} per delivery · before extra cart savings`}))];
      render(grid,choices,box.sellingPlanId,async plan=>{
        if(busy)return;busy=true;
        const form=node.closest('form'),controls=[...document.querySelectorAll('.cart-page button,.cart-page input,.cart-page select')];
        const states=controls.map(x=>[x,x.disabled]);controls.forEach(x=>x.disabled=true);
        const accelerated=document.querySelector('.cart-accelerated');if(accelerated)accelerated.hidden=true;
        const block=e=>{e.preventDefault();e.stopImmediatePropagation();};form?.addEventListener('submit',block,true);
        status.textContent='Updating this box and checking your savings…';
        try{
          await global.JoburgBoxEdit.save(api,journal,box,box.lines.map(line=>({id:line.variant_id,quantity:line.quantity,...(plan?{selling_plan:plan}:{})})),global.crypto.randomUUID());
          sessionStorage.setItem('joburg-purchase-updated',id);global.location.reload();
        }catch(error){
          status.textContent=error.message;states.forEach(([x,disabled])=>x.disabled=disabled);
          if(accelerated&&!journal.get())accelerated.hidden=false;form?.removeEventListener('submit',block,true);
          render(grid,choices,box.sellingPlanId,()=>global.location.reload());
          status.textContent+=journal.get()?' Use Finish updating your box before checkout.':' Reload the cart before choosing again.';busy=false;
        }
      });
      node.hidden=false;
      if(sessionStorage.getItem('joburg-purchase-updated')===id){sessionStorage.removeItem('joburg-purchase-updated');status.textContent='Your box is updated. The cart total includes Shopify’s applied savings.';node.scrollIntoView({block:'center'});}
    }catch(_){/* Without verified common native schedules, offer no conversion. */}
  }
  const start=()=>document.querySelectorAll('[data-cart-purchase-box]').forEach(initCart);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})(window);
